import React from 'react'
import Loader from 'react-loader-spinner'
import { Typography, styled, Card, Tooltip } from '@material-ui/core'
import AITokenActionButton from './AITokenActionButton'

const ButtonContent = styled('div')(({ isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 12px',
  cursor: 'pointer',
  background: isActive ? '#f5f5f5' : '#fff',
  boxSizing: 'border-box',
  width: '100%', // constrain row
  gap: 12,
  '& button': {
    flexShrink: 0, // button never shrinks
  },
}))

const ProductText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  flexGrow: 1,
  flexShrink: 1,
  minWidth: 0, // enables ellipsis
  maxWidth: 'calc(100% - 90px)', //  reserve space for button
})

export const productSelectorCardStyles = {
  width: 300,
  marginRight: 32,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 0px',
}

const AIProductSection = ({
  products = [],
  isLoading,
  setSelectedProduct,
  selectedProduct,
  dispatchResponse,
}) => {
  return (
    <Card style={productSelectorCardStyles}>
      <Typography variant="h2" style={{ marginBottom: 16 }}>
        Products
      </Typography>
      {isLoading && <Loader type="ThreeDots" color="grey" />}

      {products.map((product) => (
        <ButtonContent
          key={product.productSfid}
          isActive={selectedProduct === product.productSfid}
        >
          {/* Left text block */}
          <ProductText onClick={() => setSelectedProduct(product.productSfid)}>
            {/* Product name — SAME style as before */}
            <Tooltip title={product.productName} placement="top" arrow>
              <Typography
                color="textPrimary"
                style={{
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  cursor: 'default',
                }}
              >
                {product.productName}
              </Typography>
            </Tooltip>

            {/* Product code — subtle but consistent */}
            <Typography
              color="textSecondary"
              style={{
                fontSize: 'inherit',
                lineHeight: 'inherit',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
            >
              {product.productCode}
            </Typography>
          </ProductText>

          <AITokenActionButton
            action="create"
            title="Create"
            payload={product}
            dispatchResponse={dispatchResponse}
          />
        </ButtonContent>
      ))}
    </Card>
  )
}

export default AIProductSection
